import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { noop } from 'lodash';
import { useEffect } from 'react';
import { Container } from '../../../components/Advertising/CPC/components/Container.js';
import { useAdup } from '../../../components/Advertising/CPC/hooks/useAdup.js';
export const CPC = /*#__PURE__*/_styled(({
  id,
  placementKey,
  query,
  adTest = false,
  onAds = noop,
  onNoAds = noop,
  ...restProps
}) => {
  const adup = useAdup();
  useEffect(() => {
    if (adup) {
      adup.embed(id, {
        placementkey: placementKey,
        query,
        responsive: true,
        lazy: true,
        adtest: adTest,
        onAds,
        onNoAds
      });
    }
  }, [adup, id, placementKey, query, adTest, onAds, onNoAds]);
  return _jsx(Container, {
    ...restProps,
    id: id
  });
}, process.env.NODE_ENV === "production" ? {
  target: "edaeq080"
} : {
  target: "edaeq080",
  label: "CPC"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNQQy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQkciLCJmaWxlIjoiQ1BDLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IG5vb3AgfSBmcm9tICdsb2Rhc2gnO1xuaW1wb3J0IHsgdXNlRWZmZWN0IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vLi4vY29tcG9uZW50cy9BZHZlcnRpc2luZy9DUEMvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgdXNlQWR1cCB9IGZyb20gJy4uLy4uLy4uL2NvbXBvbmVudHMvQWR2ZXJ0aXNpbmcvQ1BDL2hvb2tzL3VzZUFkdXAuanMnO1xuZXhwb3J0IGNvbnN0IENQQyA9IHN0eWxlZCgoeyBpZCwgcGxhY2VtZW50S2V5LCBxdWVyeSwgYWRUZXN0ID0gZmFsc2UsIG9uQWRzID0gbm9vcCwgb25Ob0FkcyA9IG5vb3AsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgY29uc3QgYWR1cCA9IHVzZUFkdXAoKTtcbiAgICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgICAgICBpZiAoYWR1cCkge1xuICAgICAgICAgICAgYWR1cC5lbWJlZChpZCwge1xuICAgICAgICAgICAgICAgIHBsYWNlbWVudGtleTogcGxhY2VtZW50S2V5LFxuICAgICAgICAgICAgICAgIHF1ZXJ5LFxuICAgICAgICAgICAgICAgIHJlc3BvbnNpdmU6IHRydWUsXG4gICAgICAgICAgICAgICAgbGF6eTogdHJ1ZSxcbiAgICAgICAgICAgICAgICBhZHRlc3Q6IGFkVGVzdCxcbiAgICAgICAgICAgICAgICBvbkFkcyxcbiAgICAgICAgICAgICAgICBvbk5vQWRzLFxuICAgICAgICAgICAgfSk7XG4gICAgICAgIH1cbiAgICB9LCBbYWR1cCwgaWQsIHBsYWNlbWVudEtleSwgcXVlcnksIGFkVGVzdCwgb25BZHMsIG9uTm9BZHNdKTtcbiAgICByZXR1cm4gX2pzeChDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCBpZDogaWQgfSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUNQQy5qcy5tYXAiXX0= */");